"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var review_profile_controller_1 = __importDefault(require("../../../signup/student/review-profile.controller"));
var review_student_signup_html_1 = __importDefault(require("../../../signup/student/review-student-signup.html"));
var states_1 = require("../../../common/constants/states");
var time_1 = require("../../../common/helpers/time");
var InstructorCreateStudentController = /** @class */ (function () {
    function InstructorCreateStudentController(UsersModel, FlashService, $uibModal, UserService, $state) {
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.$uibModal = $uibModal;
        this.$state = $state;
        this.submitted = false;
        this.states = states_1.States;
        this.currentUser = UserService.getCurrentUser();
        this.formData = {
            dob: "",
            firstname: "",
            lastname: "",
            username: "",
            email: "",
            schoolcode: this.currentUser.school.code,
            phone: "",
            driving_experience: "",
            pickuplocation: {
                street: "",
                city: "",
                state: "",
                zip: "",
            },
            parent: {
                firstname: "",
                lastname: "",
                email: "",
                phone: "",
            },
            gender: "",
        };
        this.submitStudent = this.submitStudent.bind(this);
        this.updateDOB = this.updateDOB.bind(this);
    }
    InstructorCreateStudentController.prototype.getStudentAge = function () {
        if (!this.formData.dob) {
            return 10000000;
        }
        var dob = (0, time_1.parseMMDDYYYYDate)(this.formData.dob);
        return (0, time_1.differenceInDays)(new Date(), dob);
    };
    InstructorCreateStudentController.prototype.studentIsAMinor = function () {
        return this.getStudentAge() < 6570;
    };
    InstructorCreateStudentController.prototype.studentUnder21 = function () {
        return this.getStudentAge() < 7670;
    };
    InstructorCreateStudentController.prototype.updateDOB = function (newDate) {
        this.formData.dob = newDate.selected[0];
    };
    InstructorCreateStudentController.prototype.submitStudent = function () {
        var _this = this;
        if (this.submitted === true) {
            return;
        }
        var student = structuredClone(this.formData);
        this.modalInstance.submitted = true;
        var dob = (0, time_1.formatDateTime)((0, time_1.parseMMDDYYYYDate)(student.dob), "YYYY-MM-DD");
        var request = {
            firstname: student.firstname,
            lastname: student.lastname,
            username: student.username,
            dob: dob,
            email: student.email,
            schoolcode: this.currentUser.school.code,
            phone: student.phone,
            driving_experience: student.driving_experience,
            pickuplocation: null,
            parent: null,
            gender: null,
        };
        if (student.hasOwnProperty("gender") && student.gender) {
            request.gender = student.gender;
        }
        if (request.gender === null) {
            delete request.gender;
        }
        if (student.hasOwnProperty("pickuplocation") &&
            student.pickuplocation.street &&
            student.pickuplocation.city &&
            student.pickuplocation.state &&
            student.pickuplocation.zip) {
            request.pickuplocation = student.pickuplocation;
        }
        if (student.hasOwnProperty("parent") &&
            student.parent.firstname &&
            student.parent.lastname &&
            student.parent.email &&
            student.parent.phone) {
            request.parent = student.parent;
        }
        if (request.pickuplocation === null) {
            delete request.pickuplocation;
        }
        if (request.parent === null) {
            delete request.parent;
        }
        if (!request.username) {
            delete request.username;
        }
        this.UsersModel.adminCreateStudent(request)
            .then(function (response) {
            _this.modalInstance.submitted = false;
            _this.modalInstance.dismiss("cancel");
            _this.$state.go("drivecoach.instructor.dashboard.calendar");
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        })
            .catch(function () {
            _this.modalInstance.submitted = false;
        });
    };
    InstructorCreateStudentController.prototype.reviewProfile = function () {
        var _this = this;
        this.modalInstance = this.$uibModal.open({
            animation: true,
            template: review_student_signup_html_1.default,
            controller: review_profile_controller_1.default,
            controllerAs: "vm",
            size: "sm",
            resolve: {
                student: this.formData,
                submit: function () { return _this.submitStudent; },
            },
        });
    };
    return InstructorCreateStudentController;
}());
InstructorCreateStudentController.$inject = [
    "UsersModel",
    "FlashService",
    "$uibModal",
    "UserService",
    "$state",
];
exports.default = InstructorCreateStudentController;
